import React from 'react'
import { Box, Button, Stack, Typography } from '@mui/material'

import { TourModal } from './tour-modal'

import styles from './tour-completion-modal.module.scss'

interface TourCompletionModalProps {
	open: boolean
	onClose: () => void
}

export const TourCompletionModal: React.FC<TourCompletionModalProps> = ({ open, onClose }) => {
	return (
		<TourModal open={open} onClose={onClose} compact>
			<Box className={styles.container}>
				<Typography className={styles.title}>
					Вы завершили обучение!
				</Typography>
				<Typography className={styles.contentText}>
					Теперь вы можете использовать всю мощь ИИ⚡️
				</Typography>
				<Stack direction="row" spacing={2} className={styles.controls}>
					<Button variant="contained" onClick={onClose} className={styles.button}>
						Отлично!
					</Button>
				</Stack>
			</Box>
		</TourModal>
	)
}
